import script from "./ArticleCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./ArticleCard.vue?vue&type=script&setup=true&lang=ts"

import "./ArticleCard.vue?vue&type=style&index=0&id=640de852&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-640de852"]])

export default __exports__